import { render, staticRenderFns } from "./simpleAnswer.vue?vue&type=template&id=5fd15d78"
import script from "./simpleAnswer.vue?vue&type=script&lang=js"
export * from "./simpleAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports